var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.9992 6.58589V23.4141C29.9992 27.0521 27.0498 29.9992 23.4143 29.9992H6.58649C2.94864 29.9992 1.50843e-07 27.0497 1.50843e-07 23.4126V6.58589C-0.000769929 2.94948 2.9471 0 6.58495 0H23.415C27.0506 0 30 2.94948 30 6.58512L29.9992 6.58589Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.3493 12.0042V15.1809H21.4461L20.7692 19.5512H17.3485V29.9999H12.6626V19.5512H8.76904V15.1809H12.6626V10.7798C12.6626 8.21382 14.7449 6.13147 17.3108 6.13147H21.7095V10.0867H19.2637C18.2056 10.0867 17.3477 10.9461 17.3477 12.005L17.3493 12.0042Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsFb);
export default __webpack_public_path__ + "static/media/sns_fb.04f1af843a88e79bccc493f1598b0fa2.svg";
export { ForwardRef as ReactComponent };